import { render, staticRenderFns } from "./ClientContactCard.vue?vue&type=template&id=cfca482e&scoped=true&"
import script from "./ClientContactCard.vue?vue&type=script&lang=js&"
export * from "./ClientContactCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientContactCard.vue?vue&type=style&index=0&id=cfca482e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfca482e",
  null
  
)

export default component.exports